import React from 'react';
import TransactionsTable from './TransactionsTable';
import SearchBar from './SearchBar';
export default function HistoryTab() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchBar, null), /*#__PURE__*/React.createElement(TransactionsTable, null));
}